<div class="ui-not-found position-relative text-center">
  <p class="error-code m-0 p-0">404</p>
  <h3>
    <span class="rr-text-danger">Ooops!</span> <span class="ms-2">{{ "Page not found." }}</span>
  </h3>
  <h5>The page you are looking for doesn't exist or has been moved.</h5>
  <p-button
    styleClass="action-btn border-0 {{ !hasTheme() ? 'ag-bg-blue' : '' }}"
    [label]="eventLabel()"
    [outlined]="false"
    (onClick)="notFound.emit()"
  ></p-button>
</div>
